import React from 'react'

import PropTypes from 'prop-types'

import { SVGIcon } from '..'

import { StyledRemoveDeviceText, StyledSelectDeviceButton } from './styled/lib'

/**
 * The device selector button that toggles the device select modal.
 *
 * @param {{
 * devices: Device[],
 * toggleDeviceModal: () => void,
 * currentDevice: Device,
 * clearDevice: () => void,
 * removeIconSrc: string,
 * selectIconSrc: string,
 * selecctTitle: string,
 * }}
 * @return {React.ReactNode}
 */
const DevicePicker = ({
  devices,
  toggleDeviceModal,
  currentDevice,
  clearDevice,
  removeIconSrc,
  selectIconSrc,
  selectTitle,
  ...props
}) => {
  if (!devices.length > 0) return null

  return currentDevice ? (
    <StyledSelectDeviceButton
      onClick={clearDevice}
      aria-label="Clear device modal window"
      id="clear"
      {...props}
    >
      <SVGIcon src={removeIconSrc} />
      <StyledRemoveDeviceText>
        {currentDevice.name_pretty}
      </StyledRemoveDeviceText>
    </StyledSelectDeviceButton>
  ) : (
    <StyledSelectDeviceButton
      onClick={toggleDeviceModal}
      aria-label="Device selector modal window"
      id="select"
      {...props}
    >
      <SVGIcon src={selectIconSrc} />
      {selectTitle}
    </StyledSelectDeviceButton>
  )
}

DevicePicker.propTypes = {
  toggleDeviceModal: PropTypes.func.isRequired,
  currentDevice: PropTypes.shape({
    customerID: PropTypes.string,
    id: PropTypes.number.isRequired,
    image_location: PropTypes.string.isRequired,
    manufacturer: PropTypes.string,
    name: PropTypes.string,
    name_pretty: PropTypes.string.isRequired,
    os: PropTypes.string,
    slug: PropTypes.string.isRequired,
    vanity_name: PropTypes.string
  }),
  clearDevice: PropTypes.func.isRequired,
  removeIconSrc: PropTypes.string.isRequired,
  selectIconSrc: PropTypes.string.isRequired,
  selectTitle: PropTypes.string.isRequired,
  devices: PropTypes.arrayOf(
    PropTypes.shape({
      customerID: PropTypes.string,
      id: PropTypes.number.isRequired,
      image_location: PropTypes.string.isRequired,
      manufacturer: PropTypes.string,
      name: PropTypes.string,
      name_pretty: PropTypes.string.isRequired,
      os: PropTypes.string,
      slug: PropTypes.string.isRequired,
      vanity_name: PropTypes.string
    })
  ).isRequired
}

export default DevicePicker



// WEBPACK FOOTER //
// ./src/components/SubHeader/DevicePicker.js